import { createRouter, createWebHashHistory } from "vue-router";
import login from "@/views/login";
import store from "@/store/index";
import { localCache } from "@/utils/Cache";
import { getParams } from "@/utils/getParams";
import { codeLogin, getUserinfo } from "@/common/api/http.api.login";
import { getCookie } from "@/utils/getCookie";

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/noperssion",
    name: "noperssion",
    component: () => import("@/views/noperssion.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: login,
  },
  {
    path: "/index",
    name: "index",
    component: () => import("@/views/index"),
    children: [
      {
        // 首页
        name: "home",
        path: "/home",
        component: () => import("@/views/home"),
        meta: {
          title: "首页",
        },
      },
      {
        // 预约情况
        name: "appointmentStatus",
        path: "/appointmentStatus",
        component: () => import("@/views/appointmentStatus/index"),
        meta: {
          title: "预约情况",
        },
      },
      {
        // 场地预约
        name: "venueReservation",
        path: "/venueReservation",
        component: () => import("@/views/venueReservation/index"),
        meta: {
          title: "场地管理",
        },
      },
      {
        // 新增 编辑场地预约
        name: "addVenueReservation",
        path: "/addVenueReservation",
        component: () => import("@/views/venueReservation/addVenueReservation"),
        meta: {
          title: "场地预约",
        },
      },
      {
        // 预约审核
        name: "reservationAudit",
        path: "/reservationAudit",
        component: () => import("@/views/reservationAudit/index"),
        meta: {
          title: "预约审核",
        },
      },
      {
        // 预约审核
        name: "auditDetails",
        path: "/auditDetails",
        component: () => import("@/views/reservationAudit/auditDetails"),
        meta: {
          title: "预约审核",
        },
      },
      {
        // 配套设施
        name: "supportingFacilities",
        path: "/supportingFacilities",
        component: () => import("@/views/supportingFacilities/index"),
        meta: {
          title: "配套设施",
        },
      },
      {
        // 个性设置
        name: "personalizedSettings",
        path: "/personalizedSettings",
        component: () => import("@/views/personalizedSettings/index"),
        meta: {
          title: "个性设置",
        },
      },
      {
        // 会议预约
        name: "meetingOrder",
        path: "/meetingOrder",
        component: () =>
          import("@/views/meetingReservation/meetingReservation"),
        meta: {
          title: "会议预约",
        },
      },
      {
        // 活动预约
        name: "activityOrder",
        path: "/activityOrder",
        component: () =>
          import("@/views/activityReservation/activityReservation"),
        meta: {
          title: "会议预约",
        },
      },
      {
        // 会议、活动 预约记录
        name: "orderRecord",
        path: "/orderRecord",
        component: () => import("@/views/orderRecord/orderRecord"),
        meta: {
          title: "预约记录",
          keepAlive: true,
          isBack: false,
        },
      },
      {
        //我的预约 会议、活动
        name: "myOrder",
        path: "/myOrder",
        component: () => import("@/views/myOrder/myOrder"),
        meta: {
          title: "我的预约",
          keepAlive: true,
          isBack: false,
        },
      },
      {
        //我的抄送 会议、活动
        name: "myCC",
        path: "/myCC",
        component: () => import("@/views/myCC/myCC"),
        meta: {
          title: "我的抄送",
          keepAlive: true,
          isBack: false,
        },
      },
      {
        // 会议、活动 预约记录详情
        name: "orderDetails",
        path: "/orderDetails",
        component: () => import("@/views/orderRecord/orderDetails"),
        meta: {
          title: "预约记录详情",
        },
      },
      {
        // 参与的会议
        name: "participatedMeeting",
        path: "/participatedMeeting",
        component: () =>
          import("@/views/participatedMeeting/participatedMeeting"),
        meta: {
          title: "参与的会议",
        },
      },
      {
        // 发布任务
        name: "pushTask",
        path: "/pushTask",
        component: () => import("@/views/taskManagement/pushTask/pushTaskList"),
        meta: {
          title: "发布任务",
        },
      },
      {
        // 发布任务 新增
        name: "addTask",
        path: "/addTask",
        component: () => import("@/views/taskManagement/pushTask/pushTask"),
        meta: {
          title: "发布任务",
        },
      },
      {
        // 我的任务
        name: "myTask",
        path: "/myTask",
        component: () => import("@/views/taskManagement/myTask/myTaskList"),
        meta: {
          title: "我的任务",
        },
      },
      {
        // 我的任务 详情
        name: "myTaskDetail",
        path: "/myTaskDetail",
        component: () => import("@/views/taskManagement/myTask/myTaskDetail"),
        meta: {
          title: "我的任务",
        },
      },
      {
        // 参与分析
        name: "joinAnalysis",
        path: "/joinAnalysis",
        component: () => import("@/views/joinAnalysis/joinAnalysis"),
        meta: {
          title: "参与分析",
        },
      },
    ],
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (localCache.getCache("venueToken")) {
    next();
  } else {
    let codeValue = getParams(window.location.href.split("?")[1])?.code;
    codeValue = codeValue?.substr(0, codeValue?.indexOf("#"));
    if (codeValue) {
      codeLogin({
        code: codeValue,
      }).then((res) => {
        localCache.setCache("venueToken", res.data?.access_token);
        loadUserinfo(res.data?.access_token);
      });
    } else {
      window.location.href = store.state.menu.ownUrl;
    }
  }

  function loadUserinfo(access_token) {
    getUserinfo({
      accessToken: access_token,
    })
      .then((res) => {
        localCache.setCache("menuList", JSON.stringify(res.menuList));
        localCache.setCache("roleList", JSON.stringify(res.data?.roleList));
        localCache.setCache("userData", JSON.stringify(res.data.userInfo));
        localCache.setCache(
          "permissionList",
          JSON.stringify(res.data.permissionList)
        );
        let routeList = router.options.routes[0];
        let url = res.menuList?.[0]?.childrenList?.length
          ? res.menuList?.[0]?.childrenList?.[0]?.url
          : res.menuList?.[0]?.url;
        if (getParams(window.location.hash?.split("?")[1])?.type) {
          routeList.redirect = "/reservationAudit";
        } else if (getParams(window.location.hash?.split("?")[1])?.orderType) {
          routeList.redirect = "/orderRecord";
        } else if (window.location.hash?.substr(1) != url) {
          // 通知公告跳转子系统，路由高亮问题（任务模块）
          routeList.redirect = window.location.hash?.substr(1);
        } else {
          routeList.redirect = to.path;
        }
        localCache.setCache("activeIndex", routeList.redirect);
        next();
      })
      .catch(() => {});
  }
});
export default router;
